import { attachmentContract } from "@/api/dilivery/sales/contract";
import { attachmentDownload } from "@/api/dilivery/audit";
import { getDataInLocalStorage } from "@/utils/localStorage";
import projectAnnexMixin from "@/mixins/projectAnnexMixin";

const baseURL = process.env.VUE_APP_BASE_API;

/**
 * 合同变更公共方法混入 - 供 ContractChangeSections 子组件使用
 * 父组件使用 changeContractMixin.js（含 data + watch + methods）
 */
export default {
  mixins: [projectAnnexMixin],
  methods: {
    // ========== 判断方法 ==========
    isAnalysisProject(data) {
      return ['预付款扣款（测序分析）', '测序分析'].includes(data.projectType) && data.contractType !== 'DEVELOPMENT';
    },
    hasMoreAnalysisRequest(data) {
      return Object.keys(data.moreAnalysisRequest).length > 0;
    },
    hasProtectiveFluidInfo(data) {
      return data && data.protectiveFluidInfo && data.protectiveFluidInfo.protectiveFluidMethod;
    },
    hasPendingProtectiveFluidMail(data) {
      return data && Array.isArray(data.protectiveFluidMail) && data.protectiveFluidMail.some(item => item.trackingFlag === 0);
    },
    hasProjectAnnex(data) {
      return data && Array.isArray(data.specificProjectType) &&
        data.specificProjectType.some(p => p.annexFilePath && p.projectMainTypeId);
    },

    // ========== 数据工具 ==========
    hashTime(newKey, data) {
      try {
        if (newKey.includes('.')) {
          const keys = newKey.split('.');
          return keys.reduce((obj, key) => obj && obj[key], data);
        }
        return data[newKey];
      } catch (error) {
        console.log(error);
        return null;
      }
    },
    getData(info) {
      return this[info];
    },
    formatAmount(value) {
      if (value === null || value === undefined || value === '') return '-';
      const num = Number(value);
      if (Number.isNaN(num)) return value;
      return '¥' + num.toLocaleString('zh-CN');
    },
    compareHardDisks(oldList = [], newList = []) {
      const map = new Map();
      (oldList || []).forEach(d => {
        const key = d?.hardDiskSize ?? JSON.stringify(d);
        map.set(key, { hardDiskSize: d?.hardDiskSize, old: { projectAmount: d?.projectAmount ?? null, sampleCount: d?.sampleCount ?? null }, new: { projectAmount: null, sampleCount: null } });
      });
      (newList || []).forEach(d => {
        const key = d?.hardDiskSize ?? JSON.stringify(d);
        if (map.has(key)) {
          const obj = map.get(key);
          obj.new = { projectAmount: d?.projectAmount ?? null, sampleCount: d?.sampleCount ?? null };
          map.set(key, obj);
        } else {
          map.set(key, { hardDiskSize: d?.hardDiskSize, old: { projectAmount: null, sampleCount: null }, new: { projectAmount: d?.projectAmount ?? null, sampleCount: d?.sampleCount ?? null } });
        }
      });
      return Array.from(map.values());
    },

    // ========== 文件操作 ==========
    async download(id, type, status) {
      try {
        const annexMap = {
          contract: 'CONTRACT_ANNEX',
          senior: 'SENIOR_ANALYSIS_ANNEX',
          customized: 'CUSTOMIZED_ANALYSIS_ANNEX',
          price: 'PRICE_APPLE_ANNEX'
        };
        const annex = annexMap[type];
        const downloadURL = status === 'oldData'
          ? '/sequencing-contract/attachment/'
          : '/audit-info/attachment/';
        const url = `${baseURL}${downloadURL}${id}/${annex}?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`;
        const elink = document.createElement('a');
        elink.href = url;
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
      } catch (error) {
        console.log(error);
      }
    },
    async preview(id, type, status) {
      try {
        const annexMap = {
          contract: 'CONTRACT_ANNEX',
          senior: 'SENIOR_ANALYSIS_ANNEX',
          customized: 'CUSTOMIZED_ANALYSIS_ANNEX',
          price: 'PRICE_APPLE_ANNEX'
        };
        const annex = annexMap[type];
        if (status === 'oldData') {
          this.fileInfo = await attachmentContract(id, annex);
        } else {
          this.fileInfo = await attachmentDownload(id, annex);
        }
        this.showFile = true;
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.showFile = false;
    },
    cancel() {
      this.$emit('submit', 'cancel');
    },
  }
};
